import { getSalesApiClient } from "@/sales-tools/home-product/api/api";
export interface GetAgentLocationResult {
    locationId?: LocationId;
}

export type LocationId = "TCPN" | "REMA" | "PILO" | "FLOR" | "PCLK" | "COBOC26" | "TXHO";

export const getAgentLocation = async (): Promise<GetAgentLocationResult> => {
    const response = await getSalesApiClient().get("v1/org-chart/expert-location");
    const data = await response.json<GetAgentLocationResult>();
    return data;
};
